import styled from "@emotion/styled";
import { breakpoints, token } from "@amzn/stencil-design-tokens/js/web/utils";

const RESPONSE_GRID_COLUMNS = "minmax(0, 15fr) minmax(0, 18fr) minmax(0, 31fr) minmax(0, 36fr)";

const SPACING_200 = token("dimensions.spacing.200");
const SPACING_300 = token("dimensions.spacing.300");

export const STACKED_LAYOUT_MEDIA = `@media (max-width: ${breakpoints.m.max}px)`;

export const ResponseGridRow = styled.div({
  display: "grid",
  gridTemplateColumns: RESPONSE_GRID_COLUMNS,
  columnGap: SPACING_300,
  alignItems: "start",
  padding: `${SPACING_200} ${SPACING_300}`,
  "& > *": { minWidth: 0, overflowWrap: "anywhere" },
  [STACKED_LAYOUT_MEDIA]: {
    gridTemplateColumns: "minmax(0, 1fr)",
    rowGap: SPACING_200,
  },
});

export const ResponseGridHeaderRow = styled(ResponseGridRow)({
  paddingBlock: 0,
  [STACKED_LAYOUT_MEDIA]: { display: "none" },
});

export const ResponseCellLabel = styled.div({
  display: "none",
  [STACKED_LAYOUT_MEDIA]: { display: "block" },
});
